var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 8V2H12V8H10ZM8 2C8.26522 2 8.51957 2.10536 8.70711 2.29289C8.89464 2.48043 9 2.73478 9 3V8C9 8.275 8.89 8.525 8.705 8.705L5.415 12L4.885 11.47C4.75 11.335 4.665 11.15 4.665 10.94L4.68 10.785L5.155 8.5H2C1.445 8.5 1 8.05 1 7.5V6.5C1 6.37 1.025 6.25 1.07 6.135L2.58 2.61C2.73 2.25 3.085 2 3.5 2H8ZM8 3H3.485L2 6.5V7.5H6.39L5.825 10.16L8 7.985V3Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbDown);
export default __webpack_public_path__ + "static/media/thumb-down.bdd92dd7.svg";
export { ForwardRef as ReactComponent };